import mapValues from "lodash-es/mapValues";
import moment from "moment";
import { configuration } from "./config";
import getCurrentPageData from "./currentpage";
import { formatTime } from "../components/date-and-time/utils";

const formatJSDate = d => moment(d).format("DD/MM/YYYY");
const formatProps = props => ({
  ...props,
  dateRanges:
    props.dateRanges &&
    props.dateRanges.map(dateRange => ({
      ...dateRange,
      dateFrom: dateRange.dateFrom.format("DD/MM/YYYY"),
      dateTo: dateRange.dateTo.format("DD/MM/YYYY")
    })),
  roomDates: (props.roomDates || []).map(formatJSDate),
  experiencesDates: mapValues(props.experiencesDates, formatJSDate),
  tableDate: props.tableDate && formatJSDate(props.tableDate),
  tableTime: props.tableTime && formatTime(props.tableTime)
});

export const sendMail = async originalProps => {
  const pageData = await getCurrentPageData();
  const p = formatProps(originalProps);

  const hasRoomReservation =
    p.hasRoomKind && p.roomDates && p.roomDates.length > 0;
  const hasExperienceReservation =
    p.selectedExperiences && p.selectedExperiences.length > 0;
  const hasTableReservation =
    p.numTableGuests && p.tableDate && p.tableTime ? true : false;

  const subject =
    `[${pageData.Tenuta.Label}] Richiesta prenotazione da ${p.name} ${p.surname} per il ` +
    (hasRoomReservation
      ? `${p.roomDates[0]} - ${p.roomDates[1]}`
      : hasExperienceReservation
      ? p.selectedExperiences.map(e => p.experiencesDates[e.id]).join(", ")
      : hasTableReservation
      ? p.tableDate
      : "");

  const body = `<h1>Richiesta prenotazione</h1>
  
<p>
<b>Nome</b>: ${p.name}<br>
<b>Cognome</b>: ${p.surname}<br>
${p.country ? `<b>Paese</b>: ${p.country}<br>` : ""}
${p.postcode ? `<b>CAP</b>: ${p.postcode}<br>` : ""}
<b>Email</b>: ${p.email}<br>
<b>N. Telefono</b>: ${p.phoneNumber}<br>
</p>

${
  hasRoomReservation
    ? `<h2>Camera</h2>

<p>
<b>Data soggiorno</b>: ${p.roomDates[0]} => ${p.roomDates[1]}<br>
<b>Numero notti</b>: ${p.numNights}<br>
<b>Tipo camera</b>: ${p.roomKind.title}<br>
<b>N. ospiti</b>: ${p.numRoomGuests[0]} adulti, ${
        p.numRoomGuests[1]
      } bambini<br>
<b>Prezzo soggiorno</b>: ${p.roomPrice} euro<br>
</p>`
    : ""
}

${
  hasExperienceReservation
    ? `<h2>Esperienze</h2>

` +
      p.selectedExperiences
        .map(
          e => `<p>
<b>Titolo</b>: ${e.title}<br>
<b>Data</b>: ${p.experiencesDates[e.id]}<br>
<b>Orario</b>: ${p.experiencesTimes[e.id].join(":")}<br>
<b>N. Partecipanti</b>: ${p.numSelectedExperiencesGuests[e.id][0]} adulti, ${
            p.numSelectedExperiencesGuests[e.id][1]
          } bambini<br>
<b>Prezzo</b>: ${p.experiencesPrices[e.id]} euro<br>
<b>Descrizione</b>: ${e.description}<br>
<b>Durata</b>: ${e.duration}<br>
<b>Calici</b>: ${e.glasses}<br>
</p>`
        )
        .join("<br>")
    : ""
}

${
  hasTableReservation
    ? `<h2>Tavolo</h2>
    
<p>
<b>Numero ospiti</b>: ${p.numTableGuests}<br>
<b>Data</b>: ${p.tableDate}<br>
<b>Ora</b>: ${p.tableTime}<br>
</p>`
    : ""
}

${p.notes && `<p><b>Note</b>:<br>${p.notes}</p>`}
`;

  const fetchConfig = {
    headers: {
      "Content-Type": "application/json"
    },
    method: "POST",
    body: JSON.stringify({
      TargetName: getTarget(), //  configuration.emailTo
      Subject: subject,
      Body: body
    })
  };
  console.log("fetchConfig:", fetchConfig);
  return configuration.fakeData
    ? new Promise(resolve => setTimeout(resolve, 1000))
    : fetch(configuration.emailServiceUrl, fetchConfig);
};

// const argsToArray = ({
//   name, // 0
//   surname, // 1
//   country, // 2
//   postcode, // 3
//   email, // 4
//   phoneNumber, // 5
//   numRoomGuests, // 6+7
//   roomKind, // 8 + title=24
//   hasExperience, // 9
//   experience, // 10 + title=20 + description=21 + duration=22 + glasses=23
//   numSelectedExperiencesGuests, // 11+12
//   experienceDate, // 13
//   experienceTime, // 14
//   roomDates, // 15 + 16
//   notes, // 17
//   experiencePrice, // 18
//   roomPrice // 19
// }) => [
//   name,
//   surname,
//   country,
//   postcode,
//   email,
//   phoneNumber,
//   numRoomGuests && numRoomGuests[0],
//   numRoomGuests && numRoomGuests[1],
//   roomKind,
//   hasExperience,
//   experience,
//   numSelectedExperiencesGuests && numSelectedExperiencesGuests[0],
//   numSelectedExperiencesGuests && numSelectedExperiencesGuests[1],
//   experienceDate,
//   experienceTime,
//   roomDates && roomDates[0],
//   roomDates && roomDates[1],
//   notes,
//   experiencePrice,
//   roomPrice,
//   experience && experience.title,
//   experience && experience.description,
//   experience && experience.duration,
//   experience && experience.glasses,
//   roomKind && roomKind.title
// ];

const getTarget = () => {
  const pathname =
    (window.location.pathname.indexOf("/") === 0 ? "" : "/") +
    window.location.pathname;
  const locationParts = pathname.split("/");
  const tenuta = locationParts[3];
  const target = configuration.targetsByTenuta[tenuta];
  if (!target) {
    console.error(`Unknown tenuta ${tenuta} (url is: ${window.location.href})`);
  }
  return target;
};
